import {
  SuccessIcon_default
} from "./chunk-RK62JBXP.mjs";
export {
  SuccessIcon_default as default
};
